import { db } from '../../data/db';
import type { RodentPlan } from '../../data/types';
import { downloadBlob, loadFile } from '../../sync/files';

/** The saved station-plan PNG, from this device or the server. */
export async function loadPlanImage(plan: RodentPlan): Promise<Blob | null> {
  if (plan.snapshotFileId) return loadFile({ kind: 'file', fileId: plan.snapshotFileId });
  if (plan.snapshotDocumentId) {
    const document = await db.documents.get(plan.snapshotDocumentId);
    return loadFile({ kind: 'document', documentId: plan.snapshotDocumentId, updatedAt: document?.updatedAt || 'legacy' });
  }
  return null;
}

export const hasPlanImage = (plan: RodentPlan) => Boolean(plan.snapshotFileId || plan.snapshotDocumentId);

export async function downloadPlanImage(plan: RodentPlan) {
  const blob = await loadPlanImage(plan);
  if (!blob) { window.alert('The saved PNG is unavailable. It downloads once this device is back online.'); return; }
  downloadBlob(blob, plan.snapshotFileName || `${plan.clientName}-rodent-plan.png`);
}
